/**
 * Maps backend delivery window strings to customer-friendly labels.
 *
 * @param label - The delivery window label from the backend (e.g., "Max. 7 days")
 * @returns The customer-friendly label or null if the input is falsy
 */
export const mapDeliveryWindowLabel = (label: string | null | undefined): string | null => {
    if (!label) return null;

    const trimmed = label.trim();

    // These strings come from DeliveryDateFlexibility enum translations (e.g. "Max. 7 days")
    if (trimmed === 'Max. 7 days') {
        return 'Within 7 days';
    }

    if (trimmed === 'Max. 14 days') {
        return 'Within 2 weeks';
    }

    if (trimmed === 'Max. 21 days') {
        return 'Within 3 weeks';
    }

    if (trimmed === 'Max. 30 days') {
        return 'Within a month';
    }

    return label;
};
